function transformToHTML5(html: string) {
  return html
    .replace(/<(\/?)b\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gm, '<$1strong$2>')
    .replace(/<(\/?)i\b((?:[^>"']|"[^"]*"|'[^']*')*)>/gm, '<$1em$2>');
}

// eslint-disable-next-line import/prefer-default-export
export { transformToHTML5 };
